import { render, staticRenderFns } from "./FileExcelSolid.vue?vue&type=template&id=15af0b42&"
import script from "./FileExcelSolid.vue?vue&type=script&lang=js&"
export * from "./FileExcelSolid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports